import { SchemaFormDefinition } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { schema } from './schema';

const commonDefinition = {
    fields: {
        name: {
            label: lt('IntegrationName'),
        },
        companyName: {
            label: lt('CompanyName'),
            required: true,
        },
        taxIdentificationNumber: {
            label: lt('SpanishTaxIdentificationNumber'),
            helper: lt('SpanishTaxIdentificationNumberHelper'),
            required: true,
        },
    },
    renderFields: ['name', 'companyName', 'taxIdentificationNumber'],
} satisfies SchemaFormDefinition<typeof schema>;

export const formDefinition = {
    fields: commonDefinition.fields,
    renderFields: commonDefinition.renderFields,
} satisfies SchemaFormDefinition<typeof schema>;

export const updateFormDefinition = {
    fields: {
        name: {
            label: lt('IntegrationName'),
        },
        companyName: {
            label: lt('CompanyName'),
            required: true,
            readOnly: true,
        },
        taxIdentificationNumber: {
            label: lt('SpanishTaxIdentificationNumber'),
            helper: lt('SpanishTaxIdentificationNumberHelper'),
            required: true,
            readOnly: true,
        },
    },
    renderFields: commonDefinition.renderFields,
} satisfies SchemaFormDefinition<typeof schema>;
